import React, { useState } from 'react'
import Heading from '../UI/Heading'
import webDevelopmentImg from "../assets/service-1.png"
import appDevelopmentImg from "../assets/appdev.png"
import digitalMarketingImg from "../assets/service-2.png"
import grothImg from "../assets/service-3.png"
import marketResearchImg from "../assets/service-4.png"
import businessStrategyImg from "../assets/service-5.png"
import ItServiceImg from "../assets/service-6.png"
import { Link,   } from 'react-router-dom'
import { service } from '../Data/data'


const Service = ({setOpen}) => {
 
 
 
  return (
    <div className=" relative">
    <Heading  heading={"Our Services"} height={"200px"} text={"4xl"}/>
<div  className=" sticky top-20 max-sm:top-0  px-4 bg-[#ecf5f7] mb-8 py-8 rounded-3xl mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 shadow-inner">
      <div className="flex flex-col items-center justify-between w-full lg:flex-row max-sm:flex-col-reverse max-md:flex-col-reverse ">
        <div className="mb-16 lg:mb-0 lg:max-w-lg lg:pr-5">
          <div className="max-w-xl mb-6">
            
          <h2 className="font-sans text-3xl sm:mt-0 mt-6 font-medium tracking-tight text-black max-sm:text-xl sm:leading-none max-w-lg mb-6">
          Web Development
            </h2>
            <p className="text-black text-base max-md:text-sm leading-8 max-md:leading-9 text-justify">SocioLoom transforms your digital vision into reality with cutting-edge web development solutions. From captivating designs to seamless functionality, we craft websites that elevate your online presence. Empower your business with our customized, budget-friendly web solutions and step confidently into the digital future. Innovate with SocioLoom - Where Ideas Meet Excellence
            </p>
          </div>
          <div className='space-x-4'>
          <button className="text-[#fff]  text-lg  inline-flex items-center px-6  py-2.5 bg-[#510069] rounded">
          <Link to={`/service/${service[0].slug}`} onClick={()=>setOpen(true)}>
         <span> See More →</span>
         </Link>
          </button>
          </div>
        </div>
        <img alt="logo" width="600" height="100" src={webDevelopmentImg} className='rounded-2xl'/>
      </div>
    </div>


    <div  className=" sticky top-20 max-sm:top-0  px-4 bg-[#ecf5f7] mb-8 py-8 rounded-3xl mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 shadow-inner">
      <div className="flex flex-col items-center justify-between w-full lg:flex-row max-sm:flex-col-reverse max-md:flex-col-reverse ">
        <div className="mb-16 lg:mb-0 lg:max-w-lg lg:pr-5">
          <div className="max-w-xl mb-6">
            
          <h2 className="font-sans text-3xl sm:mt-0 mt-6 font-medium tracking-tight text-black max-sm:text-xl sm:leading-none max-w-lg mb-6">
          APP Development
            </h2>
            <p className="text-black text-base max-md:text-sm leading-8 max-md:leading-9 text-justify">SocioLoom builds powerful, scalable, and user-friendly mobile applications tailored to your business needs. In today’s digital era, a strong mobile presence is essential to connect with your customers and grow efficiently. We specialize in crafting custom Android, iOS, and cross-platform apps using the latest technologies. Whether you're a startup launching an MVP or an enterprise building a business tool, we deliver apps that are fast, secure, and intuitive. From planning to deployment and ongoing support, SocioLoom is your trusted partner in turning innovative ideas into successful mobile applications that make an impact.
            </p>
          </div>
          <div className='space-x-4'>
          <button className="text-[#fff]  text-lg  inline-flex items-center px-6  py-2.5 bg-[#510069] rounded">
          <Link to={`/service/${service[0].slug}`} onClick={()=>setOpen(true)}>
         <span> See More →</span>
         </Link>
          </button>
          </div>
        </div>
        <img alt="logo" width="600" height="100" src={appDevelopmentImg} className='rounded-2xl'/>
      </div>
    </div>




        <div className="  sticky top-20 max-sm:top-0   px-4 bg-[#e3f3f6] mb-8 py-8 rounded-3xl mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8  shadow-inner">
      <div className="flex flex-col items-center justify-between w-full  lg:flex-row">
        
        <img alt="logo" width="600" height="100" src={digitalMarketingImg} className='rounded-xl'/>


        <div className="mb-16 lg:mb-0 lg:max-w-lg lg:pr-5">
          
          <div className="max-w-xl mb-6">
            
          <h2 className="font-sans text-3xl sm:mt-0 mt-6 font-medium tracking-tight text-black max-sm:text-xl sm:leading-none max-w-lg mb-6">
          Digital Marketing
            </h2>
            <p className="text-black text-base max-md:text-sm leading-8 max-md:leading-9 text-justify">Elevate your brand's digital presence with SocioLoom's powerhouse digital marketing strategies. We specialize in targeted campaigns, SEO mastery, and captivating content that drives engagement. Whether you're a startup or an established business, our budget-friendly solutions ensure maximum impact. Join us in navigating the digital landscape with creativity and precision. Choose SocioLoom - Your Partner in Digital Success!

            </p>
          </div>
          <div className='space-x-4'>
          <button className="text-[#fff]  text-lg  inline-flex items-center px-6 py-2.5 bg-[#510069] rounded">
          <Link to={`/service/${service[1].slug}`} onClick={()=>setOpen(true)}>
          <span> See More →</span>
          </Link>
          </button>
          </div>
        </div>
      </div>
    </div>


    <div className="  sticky top-20 max-sm:top-0  px-4 bg-[#e1f9fb] mb-8 py-8 rounded-3xl mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8  shadow-inner">
      <div className="flex flex-col items-center justify-between w-full lg:flex-row max-sm:flex-col-reverse max-md:flex-col-reverse">
        <div className="mb-16 lg:mb-0 lg:max-w-lg lg:pr-5">
          <div className="max-w-xl mb-6">
            
          <h2 className="font-sans text-3xl sm:mt-0 mt-6 font-medium tracking-tight text-black max-sm:text-xl sm:leading-none max-w-lg mb-6">
          Growth Strategy
            </h2>
            <p className="text-black text-base max-md:text-sm leading-8 max-md:leading-9 text-justify">Fuel your business growth with SocioLoom's strategic process. We chart a course for success through innovative solutions in web development, digital marketing, and brand building. Our collaborative approach, coupled with affordable yet impactful strategies, ensures that your business not only survives but thrives in the dynamic digital ecosystem. Partner with SocioLoom - Where Growth Meets Strategy.
            </p>
          </div>
          <div className='space-x-4'>
          <button className="text-[#fff]  text-lg  inline-flex items-center px-6  py-2.5 bg-[#510069] rounded">
          <Link to={`/service/${service[2].slug}`} onClick={()=>setOpen(true)}>
          <span> See More →</span>
          </Link>
          </button>
          </div>
        </div>
        <img alt="logo" width="650" height="100" src={grothImg} className='rounded-xl -mt-5'/>
      </div>
    </div>
    <div className=" sticky top-20 max-sm:top-0  px-4 bg-[#dcfdf8] mb-8 py-8 rounded-3xl mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8  shadow-inner">
      <div className="flex flex-col items-center justify-between w-full  lg:flex-row ">
        
        <img alt="logo" width="520" height="100" src={marketResearchImg} className='rounded-2xl'/>


        <div className="mb-16 lg:mb-0 lg:max-w-lg lg:pr-5">
          
          <div className="max-w-xl mb-6">
            
          <h2 className="font-sans text-3xl sm:mt-0 mt-6 font-medium tracking-tight text-black max-sm:text-xl sm:leading-none max-w-lg mb-6">
          Market Research
            </h2>
            <p className="text-black text-base max-md:text-sm leading-8 max-md:leading-9 text-justify">SocioLoom pioneers market research excellence, providing businesses with deep insights to navigate dynamic landscapes. Our comprehensive market research services offer a strategic edge, guiding decisions on web development, digital marketing, and brand building. Stay ahead of trends, understand your audience, and drive success with SocioLoom's data-driven approach. Empower your business with informed choices, choose SocioLoom - Your Gateway to Market Intelligence.

            </p>
          </div>
          <div className='space-x-4'>
          <button className="text-[#fff]  text-lg  inline-flex items-center px-6 py-2.5 bg-[#510069] rounded">
          <Link to={`/service/${service[3].slug}`} onClick={()=>setOpen(true)}>
          <span> See More →</span>
          </Link>
          </button>
          </div>
        </div>
      </div>
    </div>


    <div className=" sticky top-20 max-sm:top-0  px-4 bg-[#d0f9fd] mb-8 py-8 rounded-3xl mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8  shadow-inner">
      <div className="flex flex-col items-center justify-between w-full lg:flex-row max-sm:flex-col-reverse max-md:flex-col-reverse">
        <div className="mb-16 lg:mb-0 lg:max-w-lg lg:pr-5">
          <div className="max-w-xl mb-6">
            
          <h2 className="font-sans text-3xl sm:mt-0 mt-6 font-medium tracking-tight text-black max-sm:text-xl sm:leading-none max-w-lg mb-6">
          Business Strategy
            </h2>
            <p className="text-black text-base max-md:text-sm leading-8 max-md:leading-9 text-justify">At SocioLoom, we craft bespoke business strategies tailored for success. From web development to digital marketing and brand building, our holistic approach aligns with your vision. We leverage innovation, collaboration, and budget-friendly solutions to propel your business forward. Choose SocioLoom as your strategic partner, where every idea meets a roadmap to triumph in the digital realm.
            </p>
          </div>
          <div className='space-x-4'>
          <button className="text-[#fff]  text-lg  inline-flex items-center px-6 py-2.5 bg-[#510069] rounded">
          <Link to={`/service/${service[4].slug}`} onClick={()=>setOpen(true)}>
          <span> See More →</span>
          </Link>
          </button>
          </div>
        </div>
        <img alt="logo" width="600" height="100" src={businessStrategyImg} className='rounded-xl'/>
      </div>
    </div>
    <div className="  sticky top-5 max-sm:top-0  px-4 bg-[#cafbf4]  py-8 rounded-3xl mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8  shadow-inner">
      <div className="flex flex-col items-center justify-between w-full  lg:flex-row">
        
        <img alt="logo" width="600" height="100" src={ItServiceImg} className='rounded-xl'/>


        <div className="mb-16 lg:mb-0 lg:max-w-lg lg:pr-5">
          
          <div className="max-w-xl mb-6">
            
          <h2 className="font-sans text-3xl sm:mt-0 mt-6 font-medium tracking-tight text-black max-sm:text-xl  max-w-lg mb-6">
          IT Solutions
            </h2>
            <p className="text-black text-base max-md:text-sm leading-8 max-md:leading-9 text-justify">Empower your business with SocioLoom's comprehensive IT solutions. From seamless infrastructure management to cutting-edge cybersecurity, we deliver tailored strategies that align with your goals. Our innovative approach ensures scalability, efficiency, and robust technology integration. Choose SocioLoom for reliable IT solutions that propel your business into the future with confidence.
            </p>
          </div>
          <div className='space-x-4'>
          <button className="text-[#fff]  text-lg  inline-flex items-center px-6 py-2.5 bg-[#510069] rounded">
          <Link to={`/service/${service[5].slug}`} onClick={()=>setOpen(true)}>
          <span> See More →</span>
          </Link>
          </button>
          </div>
        </div>
      </div>
    </div>
  

    




   
    </div>
  )
}

export default Service

{/* <div className="mt-10 flex flex-col items-center justify-center md:flex-row w-full text-center">
<a href="/" className="mb-3 inline-flex h-12 w-full items-center justify-center rounded bg-[#510069] px-6 font-medium tracking-wide text-white shadow-md transition focus:outline-none md:mr-4 md:mb-0 md:w-auto">
    Find Out More</a>

</div> */}
